function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useCallback } from "react";
import { SCheckboxV2 } from "../../SCheckboxV2";
import { useEditorDependencyInjectionContext } from "../providers/EditorDependencyInjectionContext";
import { SOverlaySpinner } from "../../SSpinner";
import { FileUploader } from "../FileUploader";
import { SInputV2 } from "../../SInputV2";
import { SVariablePicker } from "../..";
import { SWStateRecordType } from "@superwall-me/schema";
const VideoPropertyEditor = ({ readOnly, value, onChangeValue, onClickValue })=>{
    const uploadContext = useEditorDependencyInjectionContext();
    const { useVariablePickerItems, requiresLiquid, getRequiredPaths } = useEditorDependencyInjectionContext();
    const items = useVariablePickerItems();
    const [hasFocus, setHasFocus] = useState(false);
    const inputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState();
    const { mutateAsync: upload, isError, error, isLoading, reset: resetUploadFn } = uploadContext.useUploadFile();
    const defaultPlaceholder = "e.g. http://example.com/video.mp4";
    const placeholder = defaultPlaceholder;
    const setVideoProps = useCallback((newProps)=>{
        let defaultProps = {
            type: "property-video",
            src: "",
            autoplay: false,
            loop: false,
            muted: false,
            controls: false
        };
        const updatedValue = _object_spread({}, defaultProps, value, newProps);
        if (requiresLiquid(updatedValue.src)) {
            const requiredRecords = getRequiredPaths(updatedValue.src).map((x)=>SWStateRecordType.createId(x));
            onChangeValue && onChangeValue(_object_spread_props(_object_spread({}, updatedValue), {
                rendering: {
                    type: "liquid",
                    requiredStateIds: requiredRecords
                }
            }));
        } else {
            onChangeValue && onChangeValue(_object_spread_props(_object_spread({}, updatedValue), {
                rendering: {
                    type: "literal"
                }
            }));
        }
    }, [
        onChangeValue,
        value,
        requiresLiquid,
        getRequiredPaths
    ]);
    const uploadFile = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(file) {
            setSelectedFile(file);
            try {
                const resp = yield upload({
                    file
                });
                const { url } = resp.result;
                setVideoProps({
                    src: url
                });
            } catch (e) {}
        });
        return function uploadFile(file) {
            return _ref.apply(this, arguments);
        };
    }();
    const onHandleUpload = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(file) {
            setSelectedFile(file);
            yield uploadFile(file);
        });
        return function onHandleUpload(file) {
            return _ref.apply(this, arguments);
        };
    }();
    const onRetryUpload = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(e) {
            e.preventDefault();
            yield uploadFile(selectedFile);
        });
        return function onRetryUpload(e) {
            return _ref.apply(this, arguments);
        };
    }();
    const onInputChange = (e)=>{
        e.preventDefault();
        setVideoProps({
            src: e.target.value
        });
        if (isError) resetUploadFn();
    };
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        children: /*#__PURE__*/ _jsxs("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-[1fr,auto] items-center gap-2",
                    children: [
                        /*#__PURE__*/ _jsx(SInputV2, {
                            value: (value === null || value === void 0 ? void 0 : value.src) || "",
                            onChange: onInputChange,
                            placeholder: placeholder,
                            ref: inputRef,
                            onFocus: ()=>setHasFocus(true),
                            onBlur: ()=>setTimeout(()=>{
                                    setHasFocus(false);
                                }, 1000)
                        }),
                        /*#__PURE__*/ _jsx(FileUploader, {
                            ariaLabel: "Video Upload",
                            handleFile: onHandleUpload,
                            accept: "video/*",
                            hasError: !!error,
                            isSuiButton: true,
                            suiButtonProps: {
                                variant: "primary",
                                className: "h-[34px] !rounded-md "
                            },
                            handleRetry: onRetryUpload
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-3 pt-3 pb-2 gap-3 gap-y-4",
                    children: [
                        /*#__PURE__*/ _jsx(SCheckboxV2, {
                            value: value === null || value === void 0 ? void 0 : value.autoplay,
                            onChange: (val)=>{
                                setVideoProps({
                                    autoplay: val,
                                    muted: val ? true : (value === null || value === void 0 ? void 0 : value.muted) || false,
                                    controls: !val ? true : (value === null || value === void 0 ? void 0 : value.controls) || false
                                });
                            },
                            children: "Autoplay"
                        }),
                        /*#__PURE__*/ _jsx(SCheckboxV2, {
                            value: value === null || value === void 0 ? void 0 : value.loop,
                            onChange: (loop)=>{
                                setVideoProps({
                                    loop
                                });
                            },
                            children: "Loop"
                        }),
                        /*#__PURE__*/ _jsx(SVariablePicker, {
                            items: items,
                            asButton: true,
                            enableHotkey: hasFocus,
                            didSelect: (item)=>{
                                let text = (value === null || value === void 0 ? void 0 : value.src) || "";
                                if (inputRef.current) {
                                    var _item_liquid;
                                    const { selectionStart, selectionEnd } = inputRef.current;
                                    const beforeText = text.substring(0, selectionStart || 0).trimEnd();
                                    const textToInsert = ((_item_liquid = item.liquid) === null || _item_liquid === void 0 ? void 0 : _item_liquid.trim()) || "";
                                    const rhs = text.substring(selectionEnd || 0, text.length).trimStart();
                                    const lhs = `${beforeText}${textToInsert}`;
                                    const newPosition = lhs.length;
                                    text = `${lhs}${rhs}`;
                                    setVideoProps({
                                        src: text
                                    });
                                    setTimeout(()=>{
                                        var _inputRef_current;
                                        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
                                        if (inputRef.current) {
                                            inputRef.current.selectionStart = newPosition;
                                            inputRef.current.selectionEnd = newPosition;
                                        }
                                    }, 100);
                                } else {
                                    var _item_liquid1;
                                    setVideoProps({
                                        src: `${(value === null || value === void 0 ? void 0 : value.src) || ""}${(_item_liquid1 = item.liquid) === null || _item_liquid1 === void 0 ? void 0 : _item_liquid1.trim()}`
                                    });
                                }
                            },
                            didClose: ()=>{}
                        }),
                        /*#__PURE__*/ _jsx(SCheckboxV2, {
                            value: value === null || value === void 0 ? void 0 : value.muted,
                            disabled: value === null || value === void 0 ? void 0 : value.autoplay,
                            onChange: (muted)=>{
                                setVideoProps({
                                    muted
                                });
                            },
                            children: "Muted"
                        }),
                        /*#__PURE__*/ _jsx(SCheckboxV2, {
                            value: value === null || value === void 0 ? void 0 : value.controls,
                            disabled: !(value === null || value === void 0 ? void 0 : value.autoplay),
                            onChange: (controls)=>{
                                setVideoProps({
                                    controls
                                });
                            },
                            children: "Controls"
                        })
                    ]
                }),
                isError && /*#__PURE__*/ _jsx("div", {
                    children: error === null || error === void 0 ? void 0 : error.message
                }),
                (value === null || value === void 0 ? void 0 : value.src) && !(value === null || value === void 0 ? void 0 : value.src.startsWith("https://user-content.superwalleditor.com/")) && /*#__PURE__*/ _jsx("p", {
                    className: "text-sm opacity-50",
                    children: "External video URLs may impact performance and incur CDN costs. For best results, upload videos directly to Superwall."
                }),
                isLoading && /*#__PURE__*/ _jsx(SOverlaySpinner, {})
            ]
        })
    });
};
export default VideoPropertyEditor;
